import { Link, useNavigate } from "react-router-dom";
import ContentPage from "../../Content";
import { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import DataTable from "react-data-table-component";
import BaseUrl from "../../../utils/BaseUrl";
import CustomerStyle from "../../../utils/customerStyle";
import SwalTopEnd from "../../../utils/swal_top_end";
import { UserContext } from "../../../utils/User_check";
import can from "../../../utils/Can";

const url = BaseUrl();
const customStyles = CustomerStyle();

function Utilisateurs(){
  const [loading,setLoading] = useState(false);
  const [itemsList,setItemsList] = useState([]);
  const [itemsListFilter,setItemsListFilter] = useState([]);
  const [idUser,setIdUser] = useState(null);
  const [errors,setErrors] = useState({});
  const [error,setError] = useState();
  const [roleList,setRoleList] = useState([]);

  const [firstUser,setFirstUser] = useState({
    "nom":"",
    "prenom":"",
    "email":"",
    "tel":"",
    "role_id":"",
    "send_mail_status":"0",
    "id":""
  });
  

   const [moyen_reception_pass,setMoyenReceptionPass] = useState("email");
   const columns = [
    {
        name: 'NOM ET PRENOMS',
        selector: row => `${row.name} ${row.last_name}`,
        sortable: true,
    },
    {
      name: 'TELEPHONE',
      selector: row => row.phone,
      sortable: true,
    },
    {
      name: 'ADRESSE EMAIL',
      selector: row => row.email,
      sortable: true,
    },
    {
      name: "STATUT",
      selector : row => (
        <>
          {row.is_active == 1 && (
        <span className="badge bg-success">Actif</span>
        )}
        {row.is_active == 0 && (
            <span className="badge bg-danger">Inactif</span>
        )}
        </>
      )
    },

    {
        name: "Action",
        selector : row => (
            <>
                <button className="btn btn-warning btn-sm pb-0 mb-1 mx-1" to="#" onClick={()=>modal_edit_passsword(row.id)}><i className="fa fa-key"></i></button>
                <button className="btn btn-primary pb-0 btn-sm mx-1 mb-1" onClick={()=>open_filtre_template_modal(row)}><i class="fa-solid fa-pen"></i></button>
                {row.is_active == 1 && <button className="btn btn-success btn-sm pb-0 mb-1" to="#" onClick={()=>DesactiveFunctionUser(row.id)}><i className="fa fa-unlock"></i></button>}
                {row.is_active == 0 &&  <button className="btn btn-danger btn-sm pb-0 mb-1" to="#" onClick={()=>activeFunctionUser(row.id)}><i className="fa fa-lock"></i></button>}
            </>
        )
      },

    ];

    const {user,role, permissions} = useContext(UserContext);
    const navigate = useNavigate();
    useEffect(()=>{
    if(user && permissions && !can(permissions,'LISTE DES UTILISATEURS')){
        navigate('/page-no-found');
    }
    },[user]);

useEffect(()=>{
  fetchUserList();
  fetchRoleList();
},[]);

const fetchUserList = async ()=>{
  setLoading(true);
  try {
      axios.get(url.base+'/users-list',{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`
              
          },
      }).then((resp)=>{

          if(resp.status == 200){
              setItemsList(resp.data.data);
              setItemsListFilter(resp.data.data);
          }
          setLoading(false);
      })
  } catch (error) {
      setLoading(false);
  }
}

const fetchRoleList = async ()=>{
  setLoading(true);
  try {
      axios.get(url.base+'/role-list',{
          headers:{
              'Content-Type':'application/json',
              "Authorization": `Bearer ${localStorage.getItem('_token_')}`
              
          },
      }).then((resp)=>{

          if(resp.status == 200){
              setRoleList(resp.data.data);
          }
          setLoading(false);
      })
  } catch (error) {
      setLoading(false);
  }
}
const handleFilter=(event)=>{
  const datas = itemsListFilter.filter(row => row.name.toLowerCase().includes(event.target.value.toLowerCase()));
  setItemsList(datas);
}

const activeFunctionUser=(id)=>{
  Swal.fire({
    title: 'INFO !',
    text: 'Cette action va activer cet utilisateur.',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonText:"NON",
    confirmButtonText: 'OUI',
    cancelButtonColor:"red"
  }).then((result) => {
    if (result.isConfirmed) {
        try {
            axios.get(url.base+'/activate-or-desactivate-users/'+id,
                {
                    headers:{
                        'Content-Type':'application/json',
                        "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                        
                    },
                }
            ).then((resp)=>{
                // console.log(resp.data);
                if(resp.status == 200)
                {
           
                  Swal.fire({
                      icon: 'success',
                      title:  `Le compte a été activé avec success`,
                    });
                   
                }
                fetchUserList();
            })
        } catch (error) {
            console.log(error);
        }

    
    }
  }); 
}

const DesactiveFunctionUser=(id)=>{
Swal.fire({
  title: 'INFO !',
  text: "Cette action va désactiver cet utilisateur.",
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonText:"NON",
  confirmButtonText: 'OUI',
  cancelButtonColor:"red"
}).then((result) => {
  if (result.isConfirmed) {
      try {
          axios.get(url.base+'/activate-or-desactivate-users/'+id,
              {
                  headers:{
                      'Content-Type':'application/json',
                      "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                      
                  },
              }
          ).then((resp)=>{
              // console.log(resp.data);
              if(resp.status == 200)
              {
          
              Swal.fire({
                  icon: 'success',
                  title:  `Le compte a été désactivé avec success`,
                  });
                  
              }
              fetchUserList();
          })
      } catch (error) {
          console.log(error);
      }

  
  }
}); 
}

const ResetPassFunctionUser=(id)=>{
  Swal.fire({
    title: 'INFO !',
    text: 'Êtes vous sûre de vouloir modifier le mot de passe.',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonText:"NON",
    confirmButtonText: 'OUI',
    cancelButtonColor:"red"
  }).then((result) => {
    if (result.isConfirmed) {
        try {
            axios.get(url.base+'/reset-password-users/'+id,
                {
                    headers:{
                        'Content-Type':'application/json',
                        "Authorization": `Bearer ${localStorage.getItem('_token_')}`
                        
                    },
                }
            ).then((resp)=>{
                // console.log(resp.data);
                if(resp.status == 200)
                {
           
                  Swal.fire({
                      icon: 'success',
                      title:  `Mot de passe modifié avec succès!. Veuillez consulter votre adresse mail.`,
                    });
                   
                }
                fetchUserList();
            })
        } catch (error) {
            console.log(error);
        }

    
    }
  }); 
}
const modal_edit_passsword=(id)=>{
  setIdUser(id);
  window.$("#add-edit-modal").modal('show');
}

const submitFormNewPass=()=>{

  setLoading(true);
  try {
      axios.get(url.base+'/reset-password-users/'+idUser+'?reception='+moyen_reception_pass,
     {
         headers:{
             'Content-Type':'multipart/form-data',
             "Authorization": `Bearer ${localStorage.getItem('_token_')}`                   
         },
         credentials:'include'
     }
     ).then((resp)=>{          
         setLoading(false);
         
         if(resp.data.data == "email" || resp.data.data == "sms"){
              SwalTopEnd({icon:"success",title:"Mot de passe reinitialisé avec succès."});
         }else {
          Swal.fire({
              icon: 'success',
              title:  `Votre nouveau mot de passe est : ${resp.data.pass}`,
            });
         }
         window.$("#add-edit-modal").modal('hide');
       
     }).catch((error)=>{
      setLoading(false);
      console.log(error);
     });
 } catch (error) {
  setLoading(false);
     console.log(error.response);
 } 
}

const open_filtre_template_modal=(user)=> {
  window.$('#roleId').val('');
  window.$('#nom').val('');
  window.$('#prenom').val('');
  window.$('#email').val('');
  window.$('#tel').val('');
  window.$('#send').val('');

  setFirstUser({
    "nom":user.name,
    "prenom":user.last_name,
    "email":user.email,
    "tel":user.phone,
    "role_id":user.role_id,
    "send_mail_status":user.send_mail_status,
    "id":user.id
  });
  window.$("#exampleModalFiltre").modal('show');
}

const handleChange=(event)=>{
  setFirstUser({
    ...firstUser,
    [event.target.name]:event.target.value
  });
}

const submitForm= async(e)=>{
  e.preventDefault();
  const _formData = new FormData();

  _formData.append("name",firstUser.nom);
  _formData.append("last_name",firstUser.prenom);
  _formData.append("phone",firstUser.tel);
  _formData.append("email",firstUser.email);
  _formData.append("role_id",firstUser.role_id);
  _formData.append("send_mail_status",firstUser.send_mail_status);
  console.log(_formData);
    setLoading(true);
    try {
        axios.post(url.base+'/update-users/'+firstUser.id,_formData,
        {
            headers:{
                'Content-Type':'multipart/form-data',
                "Authorization": `Bearer ${localStorage.getItem('_token_')}`                   
            },
            credentials:'include'
        }
        ).then((resp)=>{          
          setLoading(false);

          SwalTopEnd({icon:'success',title:'Opération effectuée avec succès'});
          window.$("#exampleModalFiltre").modal('hide');
          fetchUserList();
          setErrors({});             
        }).catch((error)=>{
          console.log(error);
          setLoading(false);
          setError(error?.response?.data.message);
          setErrors(error?.response?.data.error);

        })
    } catch (error) {
    setLoading(false);
    console.log(error.response);
    } 
}

    return (
        <>
        <ContentPage>
            <div class="page-header flex-wrap">
            <div class="header-right d-flex flex-wrap mt-md-2 mt-lg-0">
                <div class="d-flex align-items-center">
                  <a href="#">
                    <p class="m-0 pr-3">Paramètres</p>
                  </a>
                  <a class="pl-3 mr-4" href="#">
                    <p class="m-0">Listes des utilisateurs</p>
                  </a>
                </div>
              </div>
              <div class="header-left">
                <Link class="btn btn-primary mb-2 mb-md-0 mr-2" to="/parametres/add-user"> Ajouter un utilisateur</Link>
              </div>
              
            </div>

            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                <div class="card-header bg-warning bg-gradient">
                      <div class="row">
                          <div class=" col-lg-3 col-md-6">
                              <input type="search" class="form-control " placeholder="Reference..." onChange={handleFilter}/>
                          </div>
                  </div>
                  </div>
                  <div class="card-body">
                    <h4 class="card-title">Utilisateurs</h4>
                    {/* <p class="card-description"> Add class <code>.table-striped</code>
                    </p> */}
                    <div class="table-responsive">
                    <DataTable 
                          columns={columns} 
                          data={itemsList}
                          customStyles={customStyles}
                          pagination
                          selectableRows
                          progressPending={loading}
                          progressComponent={
                              <>
                              <div class="text-center">
                                  <div class="spinner-border" role="status">
                                  {/* <span class="visually-hidden">Loading...</span> */}
                                  </div>
                              </div>
                              </>
                          } 
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal fade" id="add-edit-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalScrollableTitle" aria-hidden="true">
                    <div class="modal-dialog modal-md" role="document">
                        <div class="modal-content" >
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalScrollableTitle">Modifier le mot de passe</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true"></span>
                                </button>
                            </div>
                            <div class="modal-body">
                        
                                    <div class="modal-body">                 
                                        <div class="mb-3">
                                            <label class="form-label" for="textInput">Moyen de reception du nouveau mot de passe </label>
                                            <select class="form-select form-control" aria-label="Default select example" onChange={(e)=>setMoyenReceptionPass(e.target.value)}>
                                                <option value="email" selected>Recevoir par e-mail</option>
                                                {/* <option value="sms">Recevoir par sms</option> */}
                                                <option value="other">Autres</option>
                                            </select>                            
                                        </div>   
                                    </div>                          
                            
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                                {!loading && <button type="button"  class="btn btn-danger " onClick={()=>submitFormNewPass()}>Reinitialiser le mot de passe</button> }
                                {loading && <button type="button" class="btn btn-primary disabled">En Chargement...</button> }
                            </div>
                        </div>
                    </div>
            </div>

            <div class="modal fade" id="exampleModalFiltre"  tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
                    <div class="modal-dialog modal-md" role="document">
                        <form class="modal-content" onSubmit={submitForm}>
                            <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalCenterTitle">Modifier</h5>
                            <button type="button" class="btn-close" onClick={()=>window.$("#exampleModalFiltre").modal('hide')}>
                            </button>
                            </div>
                            <div class="modal-body">
                                <div className="row">
                                    <div class="mb-3 col-md-12">
                                      <label className="form-label">NOM</label>
                                      <input type="text" className="form-control" name="nom" id="nom" onChange={handleChange} value={firstUser.nom}/>
                                      {errors && errors.name && (
                                            <span className="text-danger">{errors.name[0]}</span>
                                        )}
                                    </div>  
                                    <div class="mb-3 col-md-12">
                                        <label className="form-label">PRENOMS</label>
                                            <input className="form-control fakepassword" type="text"  id="prenom" name="prenom"  onChange={handleChange}  value={firstUser.prenom}/>
                                            {errors && errors.last_name && (
                                                <span className="text-danger">{errors.last_name[0]}</span>
                                            )}
                                    </div> 
                                    <div class="mb-3 col-md-12">
                                        <label className="form-label">EMAIL</label>
                                        <input type="text" className="form-control" placeholder="" id="email" name="email" onChange={handleChange} value={firstUser.email}/>
                                        {errors && errors.email && (
                                              <span className="text-danger">{errors.email[0]}</span>
                                          )}
                                    </div> 
                                    <div class="mb-3 col-md-12">
                                        <label className="form-label">TELEPHONE</label>
                                        <input type="text" className="form-control" placeholder="" id="tel" name="tel" onChange={handleChange} value={firstUser.tel}/>
                                        {errors && errors.phone && (
                                            <span className="text-danger">{errors.phone[0]}</span>
                                        )}
                                    </div> 

                                    <div class="mb-3 col-md-6">
                                        <label className="form-label">RÔLE</label>
                                        <select  className="form-control" id="roleId" onChange={handleChange} value={firstUser.role_id} name="role_id">
                                            <option value="" selected>----</option>
                                            {roleList && roleList.map((item,index)=>
                                                <option value={item.id}>{item.name}</option>
                                            )}
                                        </select>
                                        {errors && errors.role_id && (
                                            <span className="text-danger">{errors.role_id[0]}</span>
                                        )}
                                    </div> 
                                    <div class="mb-3 col-md-6">
                                        <label className="form-label">Rapport Analyse</label>
                                        <select  id="send" className="form-control" onChange={handleChange} name="send_mail_status" value={firstUser.send_mail_status}>
                                            <option value="0">NON</option>
                                            <option value="1">OUI</option>
                                        </select>
                                    </div> 
                                </div> 
                                    
                            </div>
                            <div class="modal-footer">
                            {!loading && <button type="submit" class="btn btn-primary" >Enregistrer la modification</button>}
                                {loading && 
                                <button type="button" class= "btn btn-primary disabled form-control">Enregistrement en cours  <div class="text-center">
                                  <div class="spinner-border p-2" role="status">
                                  </div>
                                </div>
                                </button> 
                                }
                            </div>
                        </form>
                    </div>
            </div>
            </ContentPage>
        </>
    )
}

export default Utilisateurs;